<template>
    <div id="Home2">
        <!-- 承载头部位有标题，左侧有导航的页面 -->
        <vHeader2></vHeader2>
        <div>
            <el-row >
                <left v-if="$route.path != '/message'"></left>
                <router-view  v-else/>
            </el-row>
        </div>
    </div>
</template>

<script>
import vHeader2 from "@/components/common/headerSecond1";
import left from "@/components/common/left";

export default {
    name: "Home2",
    data() {
        return {

        };
    },
    components: {
        vHeader2: vHeader2,
        left: left
    },

     methods:{

    },
    created(){
        if(!this.jumpLogin()) return false
    }
};
</script>

<style>
#Home2 {
    /* background-color: #f9f9f9; */
    min-height: 830px;
}
.set-border {
    border-right: none;
    border: 1px solid #dddddd;
    margin-left: 1px;
    margin-right: 20px;
}
.bottomW {
    background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/common/home2.vue